// export const url = "https://backend.gugla.co.mz";
// export const url = "http://gugla";
export const url = "https://concursos.devbackend.marrar.co.mz";